import { Action } from '@ngrx/store';
import { NavigationExtras } from '@angular/router';

export const GO = '[Router] GO';
export const BACK = '[Router] BACK';
export const FORWARD = '[Router] FORWARD';
export const OPEN_NEO = '[Router] OPEN_NEO';

export class Go implements Action {
	readonly type = GO;

	constructor(public payload: {
		path: any[];
		query?: object;
		extras?: NavigationExtras;
	}) {}
}

export class Back implements Action {
	readonly type = BACK;
}

export class Forward implements Action {
	readonly type = FORWARD;
}

export class OpenNEO implements Action {
	readonly type = OPEN_NEO;
}

export type Actions
	= Go
	| Back
	| Forward
	| OpenNEO;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/actions/router.ts